// No need for hardcoding, values are all in correct order
const numDesigns = 2;
const vintage = [];

for ( let i = 0; i < numDesigns; i++ ) {
  const number = 100 + i;
  vintage.push( {
    number: `HV${number}`
  });
}

export default vintage ;